import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";

export const useAddSelectedCareer = (onSuccess) => {
  const queryClient = useQueryClient();
  const mutationFn = useApiRequest({
    url: `/users/me/selected-careers`,
    method: HttpMethod.Post,
  });

  return useMutation({
    mutationKey: ["add-selected-career"],
    mutationFn: (data) => mutationFn({ data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["selected-careers"] });
      onSuccess?.();
    },
  });
};
